import Vue from "vue";
import VanListItems from "@/common/vanList/vanListItems.vue"; //列表滑动翻页
import VanPullRefresh from "@/common/vanList/vanPullRefresh.vue"; //下拉刷新
import AntPopup from "@/common/popupBottom/antPopup"; //底部弹框公共组件
import TipModel from "@/common/EdgeDialog/tipModel"; //提示弹框公共组件
import DoMainModel from "@/common/EdgeDialog/DoMainModel"; //功能弹框公共组件
import resaleModel from "@/common/EdgeDialog/resaleModel"; //功能弹框公共组件
import MyModel from "@/common/EdgeDialog/customModel"; //自定义弹框签到和gift弹框 （特殊情况弹框带淡入淡出效果）
import SearchPage from "@/common/SearchTransitionPage/SearchPage.vue"; //搜索过渡页
import myCard from "@/common/ListCard/myCard.vue"; //公共卡片
import payMent from "@/common/PaymentWindow/payment.vue"; //支付窗口
import Search from "@/common/SearchInput/Search.vue"; //搜索输入框
import RepositorySearch from "@/common/SearchInput/RepositorySearch.vue"; //仓库搜索输入框
import RepositorySearchPage from "@/common/RepositorySearchPage/RepositorySearchPage.vue"; //仓库搜索输入框
import Title from "@/common/Title/Title.vue"; //顶部标题
import TitlePage from "@/common/Title/TitlePage.vue"; //顶部标题
import TitlePopup from "@/common/Title/TitlePopup.vue"; //底部弹框顶部标题
import walletTitle from "@/common/Title/walletTitle.vue"; //带钱包余额的顶部标题
import Select from "@/common/Select/Select.vue"; //选择框
import FramePopup from "@/common/FramePopup/FramePopup.vue"; //底部弹框2
import TokenLogo from "@/common/TokenLogo/TokenLogo.vue"; //token图标+价格
import MyTransition from "@/common/Transition/MyTransition.vue"; //动画
import Stepper from "@/common/myStepper/Stepper.vue"; //计数器
import PriceInput from "@/common/MyInput/PriceInput.vue"; //价格输入框
import Slider from "@/common/slider/Slider.vue"; //滑块
import PlayButton from "@/common/GoPay/PlayButton.vue"; //去支付按钮
import PaymentButton from "@/common/GoPay/PaymentButton.vue";
import TextPrompt from "@/common/EdgeDialog/TextPrompt"; //文字提示弹框
import modeBox from "@/common/EdgeDialog/ModeBox"; //弹框外壳
import PopupBox from "@/common/FramePopup/PopupBox.vue"; //底部弹框外壳
import PaymentOrGoods from "@/common/paymentPopup/PaymentOrGoods.vue"; //商品信息去支付时底部弹框
Vue.component("my-vanListItems", VanListItems);
Vue.component("my-vanPullRefresh", VanPullRefresh);
Vue.component("my-antPopup", AntPopup);
Vue.component("my-tipModel", TipModel);
Vue.component("my-doMainModel", DoMainModel);
Vue.component("my-resaleModel", resaleModel);
Vue.component("my-model", MyModel);
Vue.component("my-search", SearchPage); //搜索
Vue.component("my-card", myCard); //卡片
Vue.component("my-payment", payMent); //支付输入密码
Vue.component("my-SearchInput", Search); //搜索输入框
Vue.component("my-Title", Title); //标题
Vue.component("my-TitlePage", TitlePage); //页面模块标题
Vue.component("my-TitlePopup", TitlePopup); //标题
Vue.component("my-walletTitle", walletTitle); //标题
Vue.component("my-select", Select); //选择框
Vue.component("my-FramePopup", FramePopup); //底部弹框2
Vue.component("my-TokenLogo", TokenLogo); //底部弹框2
Vue.component("my-Transition", MyTransition); //自定义动画
Vue.component("my-Stepper", Stepper); //计数器
Vue.component("my-priceInput", PriceInput); //价格输入框
Vue.component("my-Slider", Slider); //滑块
Vue.component("my-PlayButton", PlayButton); //去支付按钮
Vue.component("my-PaymentButton", PaymentButton); //去支付按钮
Vue.component("my-TextPrompt", TextPrompt);
Vue.component("my-RepositorySearch", RepositorySearch); //仓库搜索输入框
Vue.component("my-RepositorySearchPage", RepositorySearchPage); //仓库搜索页面
Vue.component("my-ModelBox", modeBox); //中间弹框外壳 
Vue.component("my-PopupBox", PopupBox); //底部弹框外壳
Vue.component("my-PaymentOrGoods", PaymentOrGoods); //底部弹框外壳